import { useState } from 'react';
import { Button, Card, Table } from '@insight-health-ai/roseate/components';
import { Plus } from '@insight-health-ai/roseate/icons';
import { useGetServiceRequestTypes } from 'src/hooks/serviceRequest';
import { CreateServiceRequestType } from './createServiceRequestType';

export const ServiceRequestTypes = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { data: serviceRequestTypes, isLoading } = useGetServiceRequestTypes();

  const columns = [
    {
      title: 'Type',
      dataIndex: 'service_request_type',
      key: 'service_request_type',
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: 'Key',
      dataIndex: 'service_request_key',
      key: 'service_request_key',
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: 'Initial Status',
      dataIndex: 'initial_status',
      key: 'initial_status',
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: 'Mode',
      dataIndex: 'mode',
      key: 'mode',
      render: (text: string) => (
        <span className="capitalize">{text || 'chat'}</span>
      ),
    },
  ];

  return (
    <Card
      title={
        <div className="flex items-center justify-between gap-2">
          <span>Service Request Types</span>
          <div>
            <Button icon={<Plus />} onClick={() => setCreateModalOpen(true)}>
              Add Type
            </Button>
          </div>
        </div>
      }
      padding={{ body: 'none', header: 'sm' }}
    >
      <Table
        data={serviceRequestTypes || []}
        columns={columns}
        loading={isLoading}
        pagination={false}
      />
      {createModalOpen && (
        <CreateServiceRequestType
          open
          onClose={() => setCreateModalOpen(false)}
        />
      )}
    </Card>
  );
};
